import React from "react";
import { Tag } from "antd";
import Stripe from "./Stripe";
import { CONSTANTS as C } from "config";
import { getORderPaymentGateway } from "utils/Utils";
import PaymentLinkInfo from "./payment-link-info";
import AfsTransactionDetails from "./afs-transaction-details";
import { useTranslation } from "react-i18next";

export const Status = {
  PAID: {
    color: "green",
    label: "Paid",
  },
  CANCELLED: {
    color: "volcano",
    label: "Cancelled",
  },
  PENDING: {
    color: "blue",
    label: "Pending",
  },
};

export const StatusButton = ({ text, status, onClick = ()=>{}, children = null})=>{
  const { t } = useTranslation();
  return (
    <div className="flex items-center gap-1 mt-2 flex-wrap">
      {text && <span className="font-medium">{t(text)}</span>}
      {status && <Tag color={status?.color}>{t(status?.label || "Pending")}</Tag>}
      <button
        type="button"
        className="bg-blue-400 text-white px-2 py-1 rounded-md hidden-print"
        onClick={onClick}
      >
        {t("View Details")}
      </button>
    </div>
  );
}

function Index({
  orderInfo,
  children,
  paymentGatewayInfoModal,
  setPaymentGatewayInfoModal,
}) {
  return (
    <>
      {getORderPaymentGateway(orderInfo) === C.PAYMENT_GATWAYS.STRIPE ? (
        <Stripe
          orderInfo={orderInfo}
          {...{ paymentGatewayInfoModal, setPaymentGatewayInfoModal }}
        >
          {children}
        </Stripe>
      ) : orderInfo?.orderCheckoutOnlinePaymentMetadata?.cartId ? (
        <PaymentLinkInfo
          orderInfo={orderInfo}
          {...{ paymentGatewayInfoModal, setPaymentGatewayInfoModal }}
        >
          {children}
        </PaymentLinkInfo>
      ) : orderInfo?.orderCheckoutOnlinePaymentMetadata?.paymentProvider ===
        "AFS_PAYMENT" ? (
        <AfsTransactionDetails
          orderInfo={orderInfo}
          {...{ paymentGatewayInfoModal, setPaymentGatewayInfoModal }}
        >
          {children}
        </AfsTransactionDetails>
      ) : (
        <>{children}</>
      )}
    </>
  );
}

export default Index;
